import { EmployeeOffboardingAppointmentHandling } from '@prisma/client';
import { OffboardingWizardValues, StepConfig } from '../types/offboardings';

export const OFFBOARDING_MAX_DAYS_AHEAD = 29;

export const STAY_AT_SHOP_HELPER =
  "Unassigned appointments stay bookable and can be reassigned to a new provider any time from the calendar. After you submit, you'll get the chance to broadcast a message to customers with appointments after the offboarding.";

export const offboardingWizardInitialValues: OffboardingWizardValues = {
  mode: 'IMMEDIATE',
  scheduledFor: '',
  appointmentHandling: EmployeeOffboardingAppointmentHandling.STAY_AT_SHOP,
  retainCustomerAccess: 'true',
};

export const OFFBOARDING_WIZARD_STEPS: StepConfig[] = [
  {
    id: 'when',
    eyebrow: 'Timing',
    headline: 'When should this take effect?',
    lede: 'Offboard right now, or schedule it for a future date. Scheduled offboardings can be edited or canceled up until the moment they begin.',
  },
  {
    id: 'appointments',
    eyebrow: 'Appointments',
    headline: 'What happens to upcoming appointments?',
    lede: 'Decide where the artist\u2019s future appointments live after they leave. They can stay at the shop as unassigned bookings, or move with the artist to wherever they go next.',
    helperText: ({ values }) =>
      values.appointmentHandling ===
      EmployeeOffboardingAppointmentHandling.STAY_AT_SHOP
        ? STAY_AT_SHOP_HELPER
        : null,
  },
  {
    id: 'access',
    eyebrow: 'Customer access',
    headline: 'Should they keep customer access?',
    lede: 'After the offboarding completes, the artist can keep visibility into the customers they worked with at this shop, or have that access revoked.',
  },
  {
    id: 'review',
    eyebrow: 'Review',
    headline: 'Take one last look.',
    lede: 'Double-check everything before we kick things off. You can always come back and edit a scheduled offboarding before it starts.',
    helperText: ({ isEdit, employeeName }) =>
      isEdit
        ? `Save to update the scheduled offboarding for ${employeeName}. You can keep editing or cancel it any time before it kicks off.`
        : `Once confirmed, we'll begin offboarding ${employeeName}. Anything scheduled can still be edited or canceled up until it kicks off.`,
  },
];
